module.exports = __webpack_public_path__ + "static/honoraires-ceb46d56176ac1280d71f7d8c14332a9.jpg";